module.exports = __webpack_public_path__ + "img/省·级·公·司.0ee8c92a.png";